import dayjsTZ, { dayjsInTz } from "../../../../utils/dayjs";

function zoned(tz, value) {
  return tz ? dayjsInTz(tz, value) : dayjsTZ(value);
}

/**
 * Classify how to close an open shift relative to "now".
 * Previous calendar day (any time) → paharruar confirmation flow.
 * No next-day clock cutoff.
 *
 * @param {{ clockInDate?: number, clockOutDate?: number|null }} lastShift
 * @param {import('dayjs').Dayjs|number} [now]
 * @param {string} [tz] optional IANA team timezone
 * @returns {"same_day"|"forgot"|"none"}
 */
export function classifyOpenShiftClose(lastShift, now, tz) {
  if (!lastShift?.clockInDate || lastShift.clockOutDate != null) {
    return "none";
  }
  const nowDj = now != null ? zoned(tz, now) : zoned(tz);
  const inDay = zoned(tz, lastShift.clockInDate).format("DD/MM/YYYY");
  const today = nowDj.format("DD/MM/YYYY");

  if (inDay === today) return "same_day";
  return "forgot";
}

/**
 * User-facing copy for an open shift from a previous day (turn i paharruar).
 * Compact fields fit the dashboard ClockIn card; `message` stays for modals.
 */
export function overnightBannerCopy(lastShift, now, tz) {
  const kind = classifyOpenShiftClose(lastShift, now, tz);
  if (kind === "none" || kind === "same_day") return null;

  const startedAt = zoned(tz, lastShift.clockInDate);
  const startedFull = startedAt.format("DD/MM/YYYY HH:mm");
  const startedDate = startedAt.format("DD/MM/YYYY");
  const startedTime = startedAt.format("HH:mm");

  return {
    title: "Turni i harruar pa mbyllur",
    /** One-line for the small dashboard widget */
    summary: `Filloi ${startedDate} · ${startedTime}`,
    hint: "Mbylleni me datën dhe orën e sakta.",
    /** Longer copy for modals / toasts */
    message: `Turni i filluar më ${startedFull} është ende i hapur. Konfirmoni nëse mbarimi ishte të njëjtën ditë apo pas mesnatës, orën e largimit dhe arsyen.`,
    kind: "forgot",
    startedDate,
    startedTime,
  };
}
